import { Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react"

import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { Suppliers } from "~/pages/Brand/Suppliers/SuppliersRepository/Suppliers"
import { SupplierCreationModal } from "~/pages/Brand/Suppliers/SuppliersRepository/components/SupplierCreationModal"
import { SupplierFormValues } from "~/pages/Brand/Suppliers/SuppliersRepository/hooks/columns"
import useSupplierMappingForm from "~/pages/Brand/Suppliers/SuppliersRepository/utils/useSupplierMappingForm"
import { ContactDrawer } from "~/pages/SupplierPortal/TraceabilityRequests/components/ContactDrawer"

export const SuppliersSettings = () => {
  const [searchSupplier, setSearchSupplier] = useState<string>("")
  const [isDrawerOpen, drawerActions] = useDisclosure(false)
  const [isCreationModalOpen, creationModalActions] = useDisclosure(false)
  const { supplierMapping, setSupplierMapping, handleSupplierMapping } =
    useSupplierMappingForm({})
  const shouldOpenDrawerRef = useRef(false)

  const openAddSupplierModal = () => {
    creationModalActions.open()
  }

  const openAddSupplierDrawer = () => {
    drawerActions.open()
  }

  useEffect(() => {
    if (!shouldOpenDrawerRef.current) return

    const isUpdate =
      "supplierId" in supplierMapping && supplierMapping.supplierId !== ""

    if (isUpdate && !isDrawerOpen) {
      drawerActions.open()
    }
    shouldOpenDrawerRef.current = false
  }, [supplierMapping, isDrawerOpen, drawerActions])

  const handleSetInitialValuesAndOpenDrawer: Dispatch<
    SetStateAction<SupplierFormValues>
  > = (values) => {
    setSupplierMapping(values)
    shouldOpenDrawerRef.current = true
  }

  const isUpdate =
    "supplierId" in supplierMapping && supplierMapping.supplierId !== ""

  return (
    <HeaderControlsProvider>
      <Stack gap="md">
        <Suppliers
          setInitialValues={handleSetInitialValuesAndOpenDrawer}
          setFormType={() => undefined}
          openDrawer={drawerActions.open}
          searchSupplier={searchSupplier}
          setSearchSupplier={setSearchSupplier}
          openAddSupplierModal={openAddSupplierModal}
        />
        <SupplierCreationModal
          opened={isCreationModalOpen}
          onClose={creationModalActions.close}
          openDrawer={openAddSupplierDrawer}
          setInitialValues={setSupplierMapping}
          searchSupplier={searchSupplier}
        />
        <ContactDrawer
          opened={isDrawerOpen}
          setModalOpened={drawerActions}
          supplierMapping={supplierMapping}
          handleSupplierMapping={handleSupplierMapping}
          isUpdate={isUpdate}
        />
      </Stack>
    </HeaderControlsProvider>
  )
}
